import { render, staticRenderFns } from "./LPagination.vue?vue&type=template&id=99ed4bba"
import script from "./LPagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./LPagination.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LPagination.vue?vue&type=style&index=0&id=99ed4bba&prod&lang=sass"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./LPagination.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports